// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter_component_box {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
    padding: 14px 18px;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Filters/FilterComponent/filterComponent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;IAC/B,kBAAkB;AACtB","sourcesContent":[".filter_component_box {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    flex-wrap: wrap;\n    padding: 14px 18px;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
